import {useSearchOptions as useFetchSearchOptions} from "../../../hooks/useSearchOptions";
import {simListURL} from "./simTable.constants";

export const useSearchOptions = () => {
  const options = useFetchSearchOptions(simListURL, ["carrier", "iccid", "imei"]);

  const searchOptions = [
    {
      category: {label: "Carrier", value: "carrier"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.carrier,
    },
    {
      category: {label: "ICCID", value: "iccid"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.iccid,
    },
    {
      category: {label: "IMEI", value: "imei"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.imei,
    },
  ];

  return {searchOptions};
};
